import React, { Component } from 'react'
import data from './projects.json'
import {Card,CardDeck,CardColumns, Container, Row} from "react-bootstrap";
import {Link} from "react-router-dom"
import classes from './Page1.module.css'
import axios from 'axios'

class ProjectPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            objects: this.props.projects
        }
    }
    

    fun1= (objs) =>{
    console.log(objs);
    }

    // componentDidMount(){
    //     const proxyurl = "https://cors-anywhere.herokuapp.com/";
    //     console.log('renderinng now')
    //     axios.get(proxyurl+'https://mysterious-scrubland-14862.herokuapp.com/api/v1/Home/Projects')
    //         .then(response =>{
    //             console.log(response.data.data.projects)
    //             this.setState({objects: response.data.data.projects})
    //             this.props.update(response.data.data.projects)
    //         })
    //         .catch(error => {
    //             console.log(error)
    //         })
    // }

    render() {
        const {objects} = this.state
        // console.log(objects)
        return (
            <div style={{marginLeft:'5px',paddingTop:"20px"}}>
            <Container>
                <br></br>
            {/* <CardColumns> */}
            <Row className="justify-content-md-center">
                {objects.map((obj,index)=>{
                    return(
                        <Card style={{ width: '23rem',height:'22rem', margin:"5px",backgroundColor:"#A5C9CA",color:"white"}} border="dark" onClick={()=>{this.props.fun(index)}} key={index}>
                        <Link to={"/projects/"+index} className={classes.Link}>
                        <Card.Img variant="top" src={obj.image} alt={obj.Title} style={{height:"255px"}} />
                        <Card.Title style={{marginLeft:"10px",marginTop:"10px"}}>{obj.Title.slice(0,28)} ...</Card.Title>
                        <Card.Footer style={{color:"white"}}>{obj.date}</Card.Footer>
                        </Link>
                      </Card>
                    )
                })}
            </Row>
            {/* </CardColumns> */}
            <br></br>
            </Container>
            </div>
        )
    }
}

export default ProjectPage
